import PropTypes from 'prop-types';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var Variants;
(function (Variants) {
    Variants["SUCCESS"] = "success";
    Variants["WARNING"] = "warning";
    Variants["DANGER"] = "danger";
    Variants["INFORMATIVE"] = "informative";
})(Variants || (Variants = {}));
var propTypes = {
    message: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(['success', 'warning', 'danger', 'informative']),
    /**
     * DEPRECATED
     * Alias for variant, still here for backwards compatibility.
     * Shows a warning in console if passed.
     *
     * Will be removed soon.
     */
    styling: PropTypes.oneOf(['success', 'warning', 'danger', 'informative']),
    urgent: PropTypes.bool,
    /**
     * DEPRECATED
     * Use actions instead. Still here for backwards compatibility.
     * Button's text, only rendered if onClick is passed, defaults to 'Dismiss'.
     *
     * Will be removed soon.
     */
    buttonText: PropTypes.string,
    className: PropTypes.string,
    /**
     * DEPRECATED
     * Use actions or onDismiss instead. Still here for backwards compatibility.
     * Called when button is clicked, will not render button if not passed.
     *
     * Will be removed soon.
     */
    onClick: PropTypes.func,
    onDismiss: PropTypes.func,
    timeout: PropTypes.number,
    hideIcon: PropTypes.bool,
    actions: PropTypes.node,
    'data-testid': PropTypes.string,
};
var defaultProps = {
    urgent: true,
    variant: 'warning',
    buttonText: 'Dismiss',
    'data-testid': 'spoton-banner',
};

export { Variants, defaultProps, propTypes };
